// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Mainfooter/style.css
// module id = 2225
// module chunks = 29